import styles from './shell.module.css';

export interface LoadingScreenProps {
  /** Spanish description of what is loading. Keep it short: it is read aloud. */
  readonly message?: string;
}

/** Full-screen loading state. Announced politely so a screen reader reports progress. */
export function LoadingScreen({ message = 'Cargando…' }: LoadingScreenProps) {
  return (
    <div className={styles.screen} role="status" aria-live="polite">
      <div className={styles.spinner} aria-hidden="true" />
      <p className={styles.message}>{message}</p>
    </div>
  );
}
